import React from 'react';
import styled from 'styled-components';
import HeroSection from '../components/HeroSection';
import CategoriesSection from '../components/CategoriesSection';
import FeaturedProductsSection from '../components/FeaturedProductsSection';
import ScrollSection from '../components/ScrollSection';

const HomePageContainer = styled.div`
  padding-top: var(--header-h); /* Header yüksekliği kadar boşluk */
`;

const HomePage: React.FC = () => {
  return (
    <HomePageContainer>
      <HeroSection />
      <CategoriesSection />
      <FeaturedProductsSection />
      <ScrollSection />
    </HomePageContainer>
  );
};

export default HomePage;
